import * as React from "react";

import { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";
import {
  AppIconGalleryButtonProps,
  AppIconPreviewGallery,
  AppIconPreviewGalleryProps,
} from "@1js/acui-gallery-icon";

import { RibbonControlInternalProps } from "../../RibbonControlProps";

export type RibbonIconPreviewGalleryInternalProps = AppIconPreviewGalleryProps &
  AppPreviewGalleryInternalProps<AppIconGalleryButtonProps> &
  RibbonControlInternalProps;

export class RibbonIconPreviewGallery extends React.PureComponent<
  RibbonIconPreviewGalleryInternalProps,
  {}
> {
  public render() {
    return (
      <AppIconPreviewGallery
        {...this.props}
        dataAutomationType="RibbonIconPreviewGallery"
        persistMenu={true}
      />
    );
  }
}
